<template>
    <el-container >
        <el-header style="height: 100px;">
            <div class="header">
            <el-row type="flex" class="row-bg" justify="space-between" style="height: 100px;">
                <el-col :span="6">
                <div class="leftCenterBox">
                    <img src="../assets/pLogo.png" alt="" class="leftmagin">
                </div>
                </el-col>
                <el-col :span="6">
                    <div class="middleCenterBox">
                        <h1 style="color: white;">欢迎访问普来特富保养管理平台</h1>
                    </div>
                 </el-col>
                 <el-col :span="6">
              <div class="rightCenterBox ">
                  <el-link type="primary" class="rightmagin whiteText" href="https://pltfmc.platform-cn.com/pltfmtc/static/app/维保app测试版.apk"> 点击下载最新版维保App</el-link>
              </div>
            </el-col>
             </el-row>
            </div>
        </el-header>
        <el-main>
        <div class="container">
            <div class="LoginBox">
                <el-form>
                    <el-form-item label="登录名:">
                            <el-input v-model="username" style="width:300px"></el-input>
                    </el-form-item>
                    <el-form-item label="密码:">
                            <el-input v-model="password" style="width:300px ;margin-left: 1em" show-password ></el-input>
                    </el-form-item>
                    <el-form-item >
                        <el-button type="primary"  @click="login" round>登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        </el-main>
    </el-container>
</template>
<script>
import request from '@/lib/utils'
import CryptoJS from 'crypto-js'
import router from '../router'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      salt: ''
    }
  },
  methods: {
    login () {
      const that = this
      request.post('/login/loginManagerByPassword', {userName: this.username, password: CryptoJS.MD5(this.password + this.salt).toString()}).then(
        res => {
          if (res.code === 'success') {
            localStorage.setItem('auth-token', res.obj.token)
            sessionStorage.setItem('activeIndex', '1')
            router.push('/notice')
          } else {
            that.$message.error('登录失败' + res.message)
          }
        }
      ).catch(err => {
        that.$message.error('登录失败' + err)
      })
    },
    validateLogin () {
      if (localStorage.getItem('auth-token')) {
        let token = localStorage.getItem('auth-token')
        let activeIndex = sessionStorage.getItem('activeIndex')
        console.log('activeIndex:' + activeIndex)
        request.get('/login/validateToken?token=' + token).then((res) => {
          if (res.obj === true) {
            router.push('/')
          } else {
            localStorage.removeItem('auth-token')
          }
        })
      }
    }
  },
  mounted () {
    const that = this
    request.get('/login/currentSalt').then(res => {
      that.salt = res.obj
    }
    )
  }
}
</script>
<style scoped>
    .container{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        background-color: #E9EEF3;
    }
    .LoginBox{
        width: 500px;
        height: 400px;
        background-color: #E9EEF3;
        border-radius: 10px;
        margin-top: 80px;
    }
    .header{
        width: 100%;
        height: 100px;
        background-color: #4b5cc4;
    }
    .leftCenterBox{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items:center;
    width: 100%;
    height: 100%;
}
    .leftmagin{
        margin-left: 20px;
    }
    .rightCenterBox{
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: nowrap;
  align-items: center;
  height: 100px;
}
.middleCenterBox{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    height: 100px;
}
.rightmagin{
    margin-right: 20px;
}
.whiteText{
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue